import { Input } from '@factorialco/f0-react/dist/experimental'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { ContentEditorProps } from 'modules/trainings/components/content/types'
import { ContentModule } from 'modules/trainings/lib/content/Module'

const ModuleEditor = observer(({ contentItem }: ContentEditorProps<ContentModule>) => {
  return (
    <Input
      label={i18n.t('trainings.content.module_modal.label_title')}
      onChange={(value: string) => {
        contentItem.title = value
      }}
      placeholder={i18n.t('trainings.content.module_modal.label_placeholder')}
      value={contentItem.title}
      required
      size="md"
      maxLength={60}
    />
  )
})

export { ModuleEditor }
